import { Box, Switch, Typography } from '../../../../../../base-components';
import { useTranslation } from 'react-i18next';

interface Props {
    label: string;
    value: boolean;
    onToggle: (value: boolean) => void;
}

export const BooleanFilter = ({ label, value, onToggle }: Props) => {
    const { t } = useTranslation();
    return (
        <Box display="flex" alignItems="center" paddingInline={2}>
            <Typography variant="body2">
                {t('filters.displaySavedApplications')}
            </Typography>
            <Switch
                data-testid={label}
                checked={value}
                onClick={() => {
                    onToggle(!value);
                }}
            />
        </Box>
    );
};

export default BooleanFilter;
